import { render, staticRenderFns } from "./StatDualSumm.vue?vue&type=template&id=6ee9ca7a"
import script from "./StatDualSumm.vue?vue&type=script&lang=js"
export * from "./StatDualSumm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports